import { styled } from '@mui/material';

export const RemarkRowRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'stretch',
  paddingBottom: '0.5rem',
  marginBottom: '0.5rem',
  '&:not(:last-child)': {
    borderBottom: `0.1rem solid ${theme.palette.divider}`,
  },
}));

export const RemarkRowIcon = styled('div')({
  marginRight: '0.5rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const RemarkRowDelete = styled('div')({
  marginLeft: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
